<!-- <div class="columns-1 sm:columns-2 lg:columns-3 gap-4 p-2"> -->
<!-- <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-2 auto-rows-max"> -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 p-1 auto-rows-max items-start">
  @for (card of cards; track card._id) { @if (calculateItemCount(card._id) >= 0 && card.isVisible) {
  <div class="mb-4 break-inside-avoid border-2 border-primary rounded-md bg-white dark:bg-gray-800 flex flex-col">
    <!-- card header -->
    <div
      class="h-10 font-bold border-b border-[var(--borderColor)] text-black dark:text-white bg-primary flex items-center justify-center cursor-pointer relative"
      [style.background-color]="getCardColor(card.Color)"
      (click)="clickCardHeader(card)">
      @if (isSelectMode) {
      <button
        type="button"
        class="category-select-toggle"
        [ngClass]="{
          'category-select-toggle--active': areAllNotesSelectedForCard(card._id)
        }"
        (click)="toggleSelectAllForCard(card._id, $event)">
        <i class="pi" [ngClass]="areAllNotesSelectedForCard(card._id) ? 'pi-check-square' : 'pi-clone'"> </i>
      </button>
      }

      <div
        class="px-1 max-w-full text-3xl overflow-hidden whitespace-nowrap text-ellipsis text-center [direction:rtl] [unicode-bidi:plaintext] flex-1"
        [title]="card.Title">
        {{ card.Title }}
      </div>

      <button
        type="button"
        class="mx-1 inline-flex items-center justify-center text-white hover:opacity-80 cursor-pointer"
        (click)="expandCard(card, $event)"
        [attr.aria-label]="card.isExpanded ? 'Collapse card' : 'Expand card'"
        [attr.title]="card.isExpanded ? 'Collapse card' : 'Expand card'">
        <span class="material-symbols-outlined text-base">
          {{ card.isExpanded ? 'minimize' : 'add' }}
        </span>
      </button>
    </div>

    <!-- card content -->
    @if (card.isExpanded) {
    <div class="max-h-72 overflow-y-auto">
      <table class="w-full">
        <tbody>
          @for (note of getNotesForCard(card._id); track note._id) {
          <tr
            class="h-8 hover:bg-primary-400 cursor-pointer bg-primary-100"
            (click)="clickNote(note)"
            [ngClass]="{
              'font-bold': note.Status === 'Next Action',
              'italic text-[var(--textColorFaded)]':
                note.Status === 'Completed' ||
                note.Status === 'Obsolete' ||
                note.Status === 'Cancelled' ||
                note.Status === 'Expired',
              'ring-2 ring-primary-600': isNoteSelected(note._id),
              'select-mode-note': isSelectMode
            }">
            <td
              class="px-2 border border-[var(--borderColor)] w-7 max-w-7"
              [ngClass]="{
                '!bg-orange-300': note.syncStatus === 'updated',
                '!bg-red-600': note.syncStatus === 'new',
                '!line-through text-red-600': note.syncStatus === 'deleted'
              }">
              @if (!isSelectMode) {
              <a id="EditLink" [routerLink]="['/edit', note?._id]">
                <i class="pi pi-pen-to-square"></i>
              </a>
              } @else {
              <button
                type="button"
                class="flex items-center justify-center rounded border border-[var(--borderColor)] bg-white text-primary shadow-sm transition hover:-translate-y-0.5 hover:shadow"
                aria-label="Toggle selection"
                (click)="toggleSelection(note, $event)">
                <i
                  class="pi"
                  [ngClass]="{
                    'pi-check-square text-primary-600': isNoteSelected(note?._id),
                    'pi-square text-gray-400': !isNoteSelected(note?._id)
                  }">
                </i>
              </button>
              }
            </td>

            <td
              class="w-96 whitespace-normal px-2 border border-[var(--borderColor)]"
              [ngClass]="{
                '!line-through text-red-600': note.syncStatus === 'deleted',
                '!text-red-500': note.syncStatus !== 'synced' && note.syncStatus !== 'deleted'
              }">
              {{ getNoteYearPrefix(note) }}
              {{ note.Title }}
              {{ getAttachmentFlag(note) }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  } }
</div>
